module.exports = __webpack_public_path__ + "img/creatingevent.05d98eb1.gif";